import { useCallback } from 'react';

import { ContentAndHeaderQuery } from '@confluence/content-unified-query';
import { getApolloClient } from '@confluence/graphql';
import { SpaceOverviewQuery } from '@confluence/space-overview-query';
import { useSpaceHomepageId } from '@confluence/space-utils';
import { isCompanyHubSpaceKey } from '@confluence/route-manager/entry-points/companyHubUtils';

export const useForceRefetchContent = (contentId: string, spaceKey: string) => {
	const homepageId = useSpaceHomepageId(spaceKey);

	return useCallback(async () => {
		if (contentId === homepageId) {
			try {
				await getApolloClient().query({
					query: SpaceOverviewQuery,
					context: { single: true },
					fetchPolicy: 'network-only',
					variables: {
						spaceKey,
						excludeOperations: Boolean(!isCompanyHubSpaceKey(spaceKey)),
					},
				});
			} catch (error) {
				// NOTE: We intentionally swallow any possible error here as this query is only aimed
				// populate the cache with just published content. Should any error occur here after
				// successful publishing the page, the Apollo cache for the query will be invalidated
				// anyway and View Page will fetch the page and handle possible errors.
			}
		}
		if (contentId) {
			try {
				await getApolloClient().query({
					query: ContentAndHeaderQuery,
					context: { single: true },
					fetchPolicy: 'network-only',
					variables: {
						contentId,
						spaceKey,
						useNewContentTopper: true,
					},
				});
			} catch (error) {
				// NOTE: We intentionally swallow any possible error here as this query is only aimed
				// populate the cache with just published content. Should any error occur here after
				// successful publishing the page, the Apollo cache for the query will be invalidated
				// anyway and View Page will fetch the page and handle possible errors.
			}
		}
	}, [contentId, spaceKey, homepageId]);
};
